<template>
  <div class="project item">
    <div class="container custom">
      <div class="project__content list">
        <div class="project__content-breadcrumb" data-aos="fade">
          <el-breadcrumb separator="/">
            <template v-for="(item, index) in routeList">
              <el-breadcrumb-item v-if="item.meta.title" :key="index" :to="{ name: item.name }">
                {{ item.meta.title }}
              </el-breadcrumb-item>
            </template>
          </el-breadcrumb>
        </div>
        <div class="list__box">
          <div class="list__box-item" data-aos="fade-up">
            <div class="project__content-title">Explorer</div>
            <div class="project__content-subtitle">“Blockchain window” satisfies traders’ need for transparency</div>
            <div class="project__content-text">One of the reasons that Blockchain technology has agitated the world and the financial markets is Transparency. Transparency means that all transactions of the whole system must be fully visible, detailed and accessible to all traders. With the prerequisite of ensuring security and privacy, Explorer is the “Blockchain window” that satisfies traders’ need for transparency.</div>
          </div>
          <div class="list__box-item" data-aos="fade" data-aos-delay="500">
            <div class="project__content-image">
              <img class="mw100" src="/assets/images/project/explorer-image.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="project__slide" data-aos="fade" data-aos-delay="300">
      <swiper :options="slideOption" class="project__slide-list">
        <swiper-slide class="list__item">
          <img src="/assets/images/project/explorer-01.png" alt="">
        </swiper-slide>
        <swiper-slide class="list__item">
          <img src="/assets/images/project/explorer-02.png" alt="">
        </swiper-slide>
        <swiper-slide class="list__item">
          <img src="/assets/images/project/explorer-03.png" alt="">
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination"></div>
      </swiper>
      <p data-aos="fade-up">
        The simplest example is the Explorer for TimeStore system which uses “Bean” - the internal crypto currency of TimeBird for trading food and beverage . All transactions for trading or transfer or withdrawal are recorded on the blockchain and displayed detail through hashes at https://scan.timebird.network. These hashes contain transaction information such as sender’s address, recipient’s address, transaction number which have been encrypted to ensure the security and privacy for traders.
        <br>
        Explorer is considered as the “WINDOW’” on which traders can view all transactions, balance in the same PRIVATE NETWORK obviously. Depend on the needs, customer can use the TimeBird’s network & explorer or order Timebird to tailor new ones.
      </p>
    </div>
    <div class="project__feature">
      <div class="container custom">
        <div class="project__feature-title" data-aos="fade-up">5 reasons to use TimeBird’s Explorer</div>
        <div class="project__feature-box">
          <div class="box__content">
            <template v-for="(item, index) in listFeature">
              <div class="box__content-list" data-aos="fade-right" :key="index">
                <div class="list__title" v-if="item.title">
                  <div class="icon">
                    <img src="/assets/images/layouts/icon-star.png" alt="icon">
                  </div>
                  {{ item.title }}
                </div>
                <template v-for="(_item, index) in item.listFeatureItem">
                  <div class="list__item" :key="index">
                    <div class="icon">
                      <img src="/assets/images/layouts/icon-bookmark.png" alt="icon">
                    </div>
                    {{ _item.title }}
                  </div>
                </template>
              </div>
            </template>
          </div>
          <div class="box__image" data-aos="fade-left">
            <img src="/assets/images/project/feature-image.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="project__guide">
      <div class="container custom">
        <div class="project__guide-title" data-aos="fade-up">How to see transaction on Explorer</div>
        <div class="project__guide-step" data-aos="fade" data-aos-delay="500">
          <el-steps :active="active">
            <el-step></el-step>
            <el-step></el-step>
            <el-step></el-step>
          </el-steps>
          <div class="step__progress big">
            <div class="step__progress-item access" :class="{ active: active === 0 }">
              <img src="/assets/images/project/icon-access.svg" alt="icon">
            </div>
            <div class="step__progress-item copy" :class="{ active: active === 1 }">
              <img src="/assets/images/project/icon-copy.svg" alt="icon">
            </div>
            <div class="step__progress-item paste" :class="{ active: active === 2 }">
              <img src="/assets/images/project/icon-paste.svg" alt="icon">
            </div>
            <div class="step__progress-item verify" :class="{ active: active === 3 }">
              <img src="/assets/images/project/icon-verify.svg" alt="icon">
            </div>
          </div>
          <template v-if="active === 0">
            <div class="step__item">
              <div class="step__item-title">Step 1</div>
              <div class="step__item-content">Access to <a href="https://scan.timebird.network/" target="_blank" class="link">https://scan.timebird.network/</a></div>
            </div>
          </template>
          <template v-if="active === 1">
            <div class="step__item">
              <div class="step__item-title">Step 2</div>
              <div class="step__item-content">Go to profile on your application to get your address</div>
            </div>
          </template>
          <template v-if="active === 2">
            <div class="step__item">
              <div class="step__item-title">Step 3</div>
              <div class="step__item-content">Paste your address on “find” tab on <a href="https://scan.timebird.network/" target="_blank" class="link">https://scan.timebird.network/</a></div>
            </div>
          </template>
          <template v-if="active === 3">
            <div class="step__item">
              <div class="step__item-title">Step 4</div>
              <div class="step__item-content">Check balance and details as your needs on screen</div>
            </div>
          </template>
        </div>
        <div class="project__guide-button" data-aos="fade">
          <el-button @click="prev" class="button__prev" :class="{ active: active > 0 }">
            <img src="/assets/images/project/icon-chevron.svg" alt="icon">
          </el-button>
          <el-button @click="next" class="button__next" :class="{ active: active < 3 }">
            <img src="/assets/images/project/icon-chevron.svg" alt="icon">
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      active: 0,
      listFeature: [
        { title: '', listFeatureItem: [
          { title: 'Unlimit storage of transaction history ' },
          { title: 'List all detailed transactions of each address' },
          { title: 'Easy search transaction history' },
          { title: 'View the balance of each address' },
          { title: 'Offer 247 support services' },
        ]},
      ],
      slideOption: {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        speed: 800,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: -20,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
          scale: 0.8
        },
        breakpoints: {
          480: {
            slidesPerView: 2
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    routeList () {
      return this.$route.matched
    }
  },
  methods: {
    next() {
      if (this.active++ > 2) this.active = 3;
    },
    prev() {
      if (this.active-- < 1) this.active = 0;
    },
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100) 
  }
}
</script>